/* tslint:disable */
/* eslint-disable */
/**
 * compass-pro
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface JoinRequestAction
 */
export interface JoinRequestAction {
    /**
     * 
     * @type {string}
     * @memberof JoinRequestAction
     */
    auth_id: string;
    /**
     * 
     * @type {boolean}
     * @memberof JoinRequestAction
     */
    approve: boolean;
    /**
     * 
     * @type {string}
     * @memberof JoinRequestAction
     */
    group_name?: string | null;
    /**
     * 
     * @type {string}
     * @memberof JoinRequestAction
     */
    role?: string | null;
}

/**
 * Check if a given object implements the JoinRequestAction interface.
 */
export function instanceOfJoinRequestAction(value: object): value is JoinRequestAction {
    if (!('auth_id' in value) || value['auth_id'] === undefined) return false;
    if (!('approve' in value) || value['approve'] === undefined) return false;
    return true;
}

export function JoinRequestActionFromJSON(json: any): JoinRequestAction {
    return JoinRequestActionFromJSONTyped(json, false);
}

export function JoinRequestActionFromJSONTyped(json: any, ignoreDiscriminator: boolean): JoinRequestAction {
    if (json == null) {
        return json;
    }
    return {
        
        'auth_id': json['auth_id'],
        'approve': json['approve'],
        'group_name': json['group_name'] == null ? undefined : json['group_name'],
        'role': json['role'] == null ? undefined : json['role'],
    };
}

export function JoinRequestActionToJSON(json: any): JoinRequestAction {
    return JoinRequestActionToJSONTyped(json, false);
}

export function JoinRequestActionToJSONTyped(value?: JoinRequestAction | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'auth_id': value['auth_id'],
        'approve': value['approve'],
        'group_name': value['group_name'],
        'role': value['role'],
    };
}

